/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/** The page reloads onto the replacement cart, so the message waits for it here. */
const STORE_ORDER_ENDED_STORAGE_KEY = 'hs-store-order-ended';

export type StoreOrderEndedState = 'voided' | 'completed' | 'gone';

/** Used only where the site has not been authored with wording of its own. */
export const STORE_ORDER_ENDED_MESSAGES: Record<StoreOrderEndedState, string> = {
    voided: 'This order was cancelled at the venue, so we have started you a new one.',
    completed: 'This order has already been completed at the venue, so we have started you a new one.',
    gone: 'This order is no longer available at the venue, so we have started you a new one.'
};

export type StoreOrderEndedMessages = Partial<Record<StoreOrderEndedState, string | undefined>>;

/** Keeps the message for the page that loads after the guest is moved onto a new cart. */
export const carryStoreOrderEndedAcrossReload = (state: StoreOrderEndedState, authored?: StoreOrderEndedMessages): void => {
    try {
        window.sessionStorage.setItem(STORE_ORDER_ENDED_STORAGE_KEY, authored?.[state] || STORE_ORDER_ENDED_MESSAGES[state]);
    } catch (error) {
        console.log('LTS Info', 'storeorderended: the message could not be kept for the next page', error);
    }
};

/** Hands back the carried message once, and forgets it. */
export const takeStoreOrderEndedMessage = (): string | undefined => {
    try {
        const message = window.sessionStorage.getItem(STORE_ORDER_ENDED_STORAGE_KEY);
        window.sessionStorage.removeItem(STORE_ORDER_ENDED_STORAGE_KEY);

        return message || undefined;
    } catch (error) {
        console.log('LTS Info', 'storeorderended: the carried message could not be read', error);

        return undefined;
    }
};
